import { ReferenceTier } from '@/lib/apollo/query/get-applicant'

type ReferenceTierLabel =
  | 'Essential Tier'
  | 'Advanced Tier'
  | 'Advanced+ Tier'
  | 'Priority Tier'
  | 'Hybrid Tier'
  | 'Pro Tier'
  | 'Corporate Tier'
  | 'Data Collection'
  | 'Self Serve'
  | 'Self Serve Student'

export const toReferenceTierLabel = (
  referenceTier: ReferenceTier,
): ReferenceTierLabel => {
  switch (referenceTier) {
    case ReferenceTier.essential:
      return 'Essential Tier'
    case ReferenceTier.advanced:
      return 'Advanced Tier'
    case ReferenceTier.advancedPlus:
      return 'Advanced+ Tier'
    case ReferenceTier.priority:
      return 'Priority Tier'
    case ReferenceTier.hybrid:
      return 'Hybrid Tier'
    case ReferenceTier.pro:
      return 'Pro Tier'
    case ReferenceTier.corporate:
      return 'Corporate Tier'
    case ReferenceTier.dataCollection:
      return 'Data Collection'
    case ReferenceTier.selfServe:
      return 'Self Serve'
    case ReferenceTier.selfServeStudent:
      return 'Self Serve Student'
  }
}

export const isCorporateTier = (referenceTier: ReferenceTier): boolean =>
  referenceTier === ReferenceTier.corporate

export const referenceTierStylesMap: Record<
  ReferenceTier,
  {
    color: string
    backgroundColor: string
  }
> = {
  essential: {
    backgroundColor: '#34D9C3',
    color: '#111',
  },
  advanced: {
    backgroundColor: '#286758',
    color: '#fff',
  },
  advancedPlus: {
    backgroundColor: '#0D3353',
    color: '#fff',
  },
  priority: {
    backgroundColor: '#E97460',
    color: '#111',
  },
  hybrid: {
    backgroundColor: '#0A3979',
    color: '#fff',
  },
  pro: {
    backgroundColor: '#286758',
    color: '#fff',
  },
  corporate: {
    backgroundColor: '#E0E0E0',
    color: '#111',
  },
  dataCollection: {
    backgroundColor: '#E0E0E0',
    color: '#111',
  },
  selfServe: {
    backgroundColor: '#9B006A',
    color: '#ffffff',
  },
  selfServeStudent: {
    backgroundColor: '#E0FEFC',
    color: '#000000',
  },
}
